import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const manuelItems = [
  "Remplacement de sangle cassée ou usée",
  "Remplacement de cordon de tirage",
  "Remplacement d'enrouleur défectueux",
  "Réparation de manivelle bloquée",
  "Déblocage du volet coincé",
  "Réalignement et réglage du tablier",
];

export default function Manuel() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d8b84b4701e40e5f17fd299c0ec7077a.webp"
              alt="Réparation de volet roulant manuel à Strasbourg"
              className="w-full h-[400px] md:h-[500px]"
              loading="lazy"
              width={700}
              height={500}
            />
          </div>
          <div>
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-4">
              <strong className="text-brand-blue">Volet roulant manuel</strong> : ce que nous réparons
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Le volet roulant manuel est souvent le plus simple à réparer, mais il subit une usure régulière sur la sangle, le cordon et l'enrouleur. Si votre volet ne remonte plus, descend de travers ou si la sangle est cassée, nous intervenons rapidement pour remplacer la pièce défectueuse et remettre le mécanisme en état. Nos techniciens travaillent sur tous les modèles de volets manuels, quelle que soit la marque ou l'année de pose.
            </p>
            <ul className="space-y-3">
              {manuelItems.map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-blue text-base font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}